import styled, {css} from "styled-components"

import {Hr} from "@irati/ui/src/Layout"

export const Container = styled.div`
  ${({theme}) => css`
    margin-top: ${theme.spacing.one};
    border-radius: ${theme.border.radius.small};
    background-color: ${theme.colors.utility.white};
    box-shadow: ${theme.shadows.low};
  `}
  position: absolute;
  z-index: 10;
  left: 0;
  right: 0;
`

export const OptionsWrapper = styled.div`
  max-height: 240px;
  overflow-y: scroll;

  label:first-child div {
    ${({theme}) => css`
      border-top-left-radius: ${theme.border.radius.small};
      border-top-right-radius: ${theme.border.radius.small};
    `};
  }
`

export const SelectAllWrapper = styled.div``

export const StyledHr = styled(Hr)`
  display: none;

  ${({theme}) => theme.mediaQueries.minWidthMedia.desktop`
    display: block;
    margin: ${theme.spacing.one} 0;
    border-top: 1px solid ${theme.colors.primary2_50};
  `}
`
